export default __webpack_public_path__ + "static/media/water.8d75d7ca.jpg";